import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const menuRouter = [
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
    },
    component: () => import('./views/home/home.vue'),
  },
  // {
  //   path: "/appIndex",
  //   name: "appIndex",
  //   meta: {
  //     title: "移动端"
  //   },
  //   component: () => import("./views/appIndex/index.vue")
  // },
  {
    path: '/cases',
    name: 'cases',
    meta: {
      title: '云课件',
    },
    component: () => import('./views/cases/cases.vue'),
    redirect: '/cases/index',
    children: [
      {
        path: 'index',
        name: 'caseIndex',
        meta: {
          title: '云课件',
        },
        component: () => import('./views/cases/children/index/index.vue'),
      },
      {
        path: 'detail/:id',
        name: 'caseDetal',
        meta: {
          title: '案列库详情',
        },
        component: () => import('./views/cases/children/detail/detail.vue'),
      },
      {
        path: 'coures/:id',
        name: 'caseCourse',
        meta: {
          title: '上传课件',
        },
        component: () => import('./views/cases/children/detail/coures.vue'),
      },
      {
        path: '/extend',
        name: 'extend',
        meta: {
          title: '火热招商中—高环保水性EAU复合树脂彩色路面',
        },
        component: () => import('./views/extend/extend.vue'),
      },
      {
        path: 'trace/:id',
        name: 'caseTrace',
        meta: {
          title: '案列库-项目回顾',
        },
        component: () => import('./views/cases/children/trace/trace.vue'),
      },
    ],
  },
  {
    path: '/originality',
    name: 'originality',
    meta: {
      title: '匠心记',
    },
    component: () => import('./views/originality/originality.vue'),
    children: [
      {
        path: 'detail/:id',
        name: 'jxjDetail',
        meta: {
          title: '匠心记-详情',
        },
        component: () =>
          import('./views/originality/children/detail/detail.vue'),
      },
      {
        path: 'postDetail/:id',
        name: 'jxjPostDetail',
        meta: {
          title: '匠心记-帖子详情',
        },
        component: () =>
          import('./views/originality/children/postDetail/postDetail.vue'),
      },
      {
        path: 'postDetails/:id',
        name: 'jxjPostDetails',
        meta: {
          title: '匠心记-帖子详情',
        },
        component: () =>
          import('./views/originality/children/postDetail/testpostDetail.vue'),
      },
      {
        path: 'imgDetail/:id',
        name: 'jxjImgDetail',
        meta: {
          title: '匠心记-图文详情',
        },
        component: () =>
          import('./views/originality/children/detail/detail.vue'),
      },
      {
        path: 'createQE/:id',
        name: 'createQE',
        meta: {
          title: '匠心记-创建报告',
        },
        component: () =>
          import('./views/originality/children/createQE/createQE.vue'),
      },
      {
        path: 'createQEReport/:id',
        name: 'createQEReport',
        meta: {
          title: '匠心记-创建报告',
        },
        component: () =>
          import('./views/originality/children/createQE/newCreateQE.vue'),
        //import('./views/originality/children/createQE/testQE.vue'),
      },
      {
        path: 'updateQEReport/:id/:qeId',
        name: 'updateQEReport',
        meta: {
          title: '匠心记-创建报告',
        },
        component: () =>
          import('./views/originality/children/createQE/newUpdateQE.vue'),
      },
      {
        path: 'testQE/:id/:qeId',
        name: 'testQE',
        meta: {
          title: '匠心记-创建报告',
        },
        component: () =>
        import('./views/originality/children/createQE/testQE.vue'),
      },
      {
        path: 'detailQEReport/:id/:qeId',
        name: 'detailQEReport',
        meta: {
          title: '匠心记-报告详情',
        },
        component: () =>
          import('./views/originality/children/createQE/newViewQE.vue'),
      },
      {
        path: 'createDaliy/:id',
        name: 'createDaliy',
        meta: {
          title: '匠心记-创建日报',
        },
        component: () =>
          import('./views/originality/children/createDaliy/createDaliy.vue'),
      },
      {
        path: 'createReport/:id',
        name: 'createReport',
        meta: {
          title: '匠心记-创建周报',
        },
        component: () =>
          import('./views/originality/children/createReport/createReport.vue'),
      },
      {
        path: 'createTestReport/:id',
        name: 'createTestReport',
        meta: {
          title: '匠心记-创建报告',
        },
        component: () =>
          import('./views/originality/children/createTestReport/createTestReport.vue'),
      },
      {
        path: 'reportImg',
        name: 'reportImg',
        meta: {
          title: '匠心记-检测报告',
        },
        component: () =>
          import('./views/originality/children/createTestReport/reportImg.vue'),
      },
      {
        path: 'modifyProject/:id',
        name: 'modifyProject',
        meta: {
          title: '匠心记-项目修改',
        },
        component: () =>
          import('./views/originality/children/modifyProject/modifyProject.vue'),
      },
      {
        path: 'apply',
        name: 'jxjApply',
        meta: {
          title: '匠心记-申请',
        },
        component: () => import('./views/originality/children/apply/apply.vue'),
      },
      {
        path: 'create',
        name: 'jxjCreate',
        meta: {
          title: '匠心记-创建告知函',
        },
        component: () =>
          import('./views/originality/children/create/create.vue'),
      },
      //新添加申请
      {
        path: 'inForm',
        name: 'inForm',
        meta: {
          title: '匠心记-新申请',
        },
        component: () =>
          import('./views/originality/children/newJxjApply/inForm.vue'),
      },
      //新添加申请
      {
        path: 'upload',
        name: 'upload',
        meta: {
          title: '匠心记-新申请',
        },
        component: () =>
          import('./views/originality/children/newJxjApply/upload.vue'),
      },
      {
        path: 'newJxjApply',
        name: 'newJxjApply',
        meta: {
          title: '匠心记-新申请',
        },
        component: () =>
          import('./views/originality/children/newJxjApply/newJxjApply.vue'),
      },
      {
        path: 'visaFlowIndex/:id/:pageIndex',
        name: 'visaFlowIndex',
        meta: {
          title: '匠心记-签证流',
        },
        component: () =>
          import('./views/originality/children/visaflow/visaflowIndex.vue'),
      },
      {
        path: 'logisticsIndex/:id/:pageIndex/:State',
        name: 'logisticsIndex',
        meta: {
          title: '匠心记-协作流',
        },
        component: () =>
          import('./views/originality/children/logistics/logisticsIndex.vue'),
      },
      {
        path: 'logisticsOrder/:id',
        name: 'logisticsOrder',
        meta: {
          title: '匠心记-协作流',
        },
        component: () =>
          import('./views/originality/children/logistics/logisticsOrder.vue'),
      },
    ],
  },
  // {
  //   path: "/enterprise",
  //   name: "enterprise",
  //   meta: {
  //     title: "行业圈3"
  //   },
  //   redirect: "/enterprise/index",
  //   component: () => import("./views/enterprise/enterprise.vue"),
  //   children: [
  //     {
  //       path: "index",
  //       name: "enterIndex",
  //       meta: {
  //         title: "行业圈-首页"
  //       },
  //       component: () => import("./views/enterprise/children/index/index.vue")
  //     },
  //     {
  //       path: "detail/:id",
  //       name: "enterDetail",
  //       meta: {
  //         title: "行业圈-详情"
  //       },
  //       component: () => import("./views/enterprise/children/detail/detail.vue")
  //     },
  //     {
  //       path: "edit/:id",
  //       name: "enterEdit",
  //       meta: {
  //         title: "行业圈-编辑"
  //       },
  //       component: () => import("./views/enterprise/children/edit/edit.vue")
  //     },
  //     {
  //       path: "course/:id",
  //       name: "enterCourse",
  //       meta: {
  //         title: "行业圈-课程"
  //       },
  //       component: () => import("./views/enterprise/children/course/course.vue")
  //     }
  //   ]
  // },
  {
    path: '/news',
    name: 'news',
    meta: {
      title: '绿建要闻',
    },
    component: () => import('./views/news/news.vue'),
    redirect: '/news/index',
    children: [
      {
        path: 'index',
        name: 'newsIndex',
        meta: {
          title: '绿建要闻-首页',
        },
        component: () => import('./views/news/children/index/index.vue'),
      },
      {
        path: 'detail/:id',
        name: 'newsDdetail',
        meta: {
          title: '绿建要闻 - 详情',
        },
        component: () => import('./views/news/children/detail/detail.vue'),
      },
    ],
  },
  {
    path: '/cloud',
    name: 'cloud',
    meta: {
      title: '云方案',
    },
    component: () => import('./views/cloud/cloud.vue'),
    redirect: '/cloud/index',
    children: [
      {
        path: 'index',
        name: 'cloudIndex',
        meta: {
          title: '云方案',
        },
        component: () => import('./views/cloud/children/index/index.vue'),
      },
      {
        path: 'detail/:id',
        name: 'cloudDetail',
        meta: {
          title: '云方案',
        },
        component: () => import('./views/cloud/children/detail/detail.vue'),
      },
    ],
  },
  {
    path: '/mall',
    name: 'mall',
    meta: {
      title: '云商城',
    },
    component: () => import('./views/mall/mall.vue'),
    redirect: '/mall/index',
    children: [
      {
        path: 'index',
        name: 'mallIndex',
        meta: {
          title: '商城-首页',
        },
        component: () => import('./views/mall/children/index/index.vue'),
      },
      {
        path: 'detail/:id',
        name: 'mallDetail',
        meta: {
          title: '商城-详情',
        },
        component: () => import('./views/mall/children/detail/detail.vue'),
      },
      {
        path: 'detailBack',
        name: 'detailBack',
        meta: {
          title: '商城后台-详情',
        },
        component: () => import('./views/mall/children/detail/detailBack.vue'),
      },
      {
        path: 'searchIndex',
        name: 'searchIndex',
        meta: {
          title: '商城-搜索页',
        },
        component: () => import('./views/mall/children/index/searchIndex.vue'),
      },
    ],
  },
  {
    path: '/help',
    name: 'help',
    meta: {
      title: '联系我们',
    },
    redirect: '/help/contactUs',
    component: () => import('./views/help/help.vue'),
    children: [
      {
        path: 'aboutUs',
        name: 'aboutUs',
        meta: {
          title: '关于我们',
        },
        component: () => import('./views/help/children/aboutUs.vue'),
      },
      {
        path: 'contactUs',
        name: 'contactUs',
        meta: {
          title: '联系我们',
        },
        component: () => import('./views/help/children/contactUs.vue'),
      },
    ],
  },
  {
    path: '/showroom',
    name: 'showroom',
    meta: {
      title: '展厅',
    },
    component: () => import('./views/showroom/showroom.vue'),
  },
];
export const centerRouter = [
  {
    path: '/center',
    name: 'center',
    meta: {
      title: '个人中心',
    },
    component: () => import('./views/center/center.vue'),
  },
];
let router = new Router({
  linkActiveClass: 'active',
  // mode: 'history',
  routes: [
    {
      path: '',
      name: 'default',
      redirect: '/home',
    },
    ...menuRouter,
    ...centerRouter,
  ],
});
router.afterEach((route) => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
});

export default router;
